import {
    hollowShootRestrictionName,
    hollowShootRestrictionTranslationKey
} from '../manufacturer-platform/retailers/rights-management/retailer-access-rights/retailer-access-rights.service';
import { FcProductName } from 'types';

export enum Channel {
    Platform = 'products',
    Erp = 'internal',
    DigitalWindow = 'product_catalog',
    Ecommerce = 'ecommerce',
    MarketingMaterial = 'marketing_material',
    Reorder = 'reorder',
    Excalibur = 'excalibur',
    Preorder = 'preorder'
}

export const channelTranslationKeys = {
    [Channel.Platform]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.FASHION_CLOUD',
    [Channel.Erp]: 'RIGHTS_MANAGEMENT_CHANNELS.INTERNAL',
    [Channel.DigitalWindow]: 'RIGHTS_MANAGEMENT_CHANNELS.PRODUCT_CATALOG',
    [Channel.Ecommerce]: 'RIGHTS_MANAGEMENT_CHANNELS.ECOMMERCE',
    [Channel.MarketingMaterial]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.MARKETING',
    [Channel.Reorder]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.ENDLESS_AISLE',
    [Channel.Excalibur]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.EXCALIBUR',
    [Channel.Preorder]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.PREORDER'
};

export enum LegalRight {
    MarketingFiles = 'canUseMarketingFiles',
    DigitalShopWindow = 'canUseForDigitalShopWindow',
    Ecommerce = 'canUseForEcommerce',
    Erp = 'canUseForErp',
    ProductData = 'canUseProductData',
    EndlessAisle = 'canUseEndlessAisle',
    B2bPlatform = 'canUseB2bPlatform',
    PreorderPlatform = 'canUsePreorderPlatform',
    AutoRestock = 'canUseAutoRestock'
}

export const legalRightTranslationKeys = {
    [LegalRight.ProductData]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.FASHION_CLOUD',
    [LegalRight.Erp]: 'RIGHTS_MANAGEMENT_CHANNELS.INTERNAL',
    [LegalRight.DigitalShopWindow]: 'RIGHTS_MANAGEMENT_CHANNELS.PRODUCT_CATALOG',
    [LegalRight.Ecommerce]: 'RIGHTS_MANAGEMENT_CHANNELS.ECOMMERCE',
    [LegalRight.MarketingFiles]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.MARKETING',
    [LegalRight.EndlessAisle]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.ENDLESS_AISLE',
    [LegalRight.B2bPlatform]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.EXCALIBUR',
    [LegalRight.PreorderPlatform]: 'RIGHTS_MANAGER.RIGHTS_CATEGORIES.PREORDER',
    [LegalRight.AutoRestock]: 'Autorestock',
    [hollowShootRestrictionName]: hollowShootRestrictionTranslationKey
};

export enum BrandAccessRight {
    MarketingMaterial = 'marketingMaterial',
    ProductData = 'productData',
    EndlessAisle = 'endlessAisle',
    ReorderPlatform = 'reorderPlatform',
    PreorderPlatform = 'preorderPlatform',
    ContentPlatform = 'contentPlatform'
}

export const brandAccessRightToProductKeyMap = {
    [BrandAccessRight.ContentPlatform]: FcProductName.ContentPlatform,
    [BrandAccessRight.ProductData]: FcProductName.ContentPlatform,
    [BrandAccessRight.MarketingMaterial]: FcProductName.ContentPlatform,
    [BrandAccessRight.PreorderPlatform]: FcProductName.PreorderPlatform,
    [BrandAccessRight.ReorderPlatform]: FcProductName.OrderPlatform,
    [BrandAccessRight.EndlessAisle]: FcProductName.EndlessAisle
};

// reuse-no-access: add the path to productPlatform name map
export const pathToProductNameMap = {
    '/preorder/no-access': BrandAccessRight.PreorderPlatform,
    '/reorder/no-access': BrandAccessRight.ReorderPlatform,
    '/content/products/no-access': BrandAccessRight.ProductData,
    '/content/marketing/no-access': BrandAccessRight.MarketingMaterial
};
